/**
 * RU on all settings including whitelisting
 * This is in common as all apps would need it
 * Setting Key value pairs come from db of the app.
 */
import { Entity } from '../common/base/entity/entity'
// import {EntityComponent} from '../entity'
import { methodSchemas, entitySchema, collectionSchemas } from './userQueue.schema'
import { alertActions } from '../common'
import {userQueueAction}from './userQueueAction'
// import {    baseConstants} from '../../entity';

/**
 * Instructions: 
 * 1. For simple usage steps:
 * a. fieldsMeta, actionsMeta, screens, sectionsMeta definition and creation of BaseEntity obj with these inputs
 * 2. For simple overrides of baseEntity 
 * a. create an extended class of baseEntity and override its methods...
 * 3. For more customization
 * a. create a derived Service, derived actions and use them in derived BasedEntity class.
 * b. for component customization pass those components to the constuctor of derived BaseEntity class. SearchList component is the root component.
 *
 * 
 */


class UserQueueEntity extends Entity {
    // override the following if needed.
    // derived actionObj
    // derived Service obj
    // getActionFns if you want to suppress the baseActionobj methods
    // getActionFns() {
    //     let fns = super.getActionFns()
    //     let that = this
    //     return {
    //         ...fns,

    //         addNewItem: (itemData, customerTenantID) => {
    //             // No Create allowed on Settings.
    //             return dispatch => {
    //                 let errorMsg = 'Creating ' + that.name + ' is not allowed'
    //                 dispatch(fns.failure('ADDNEW', errorMsg));
    //                 dispatch(alertActions.error(errorMsg));
    //             }
    //         },
    //         deleteItem: (id, customerTenantID) => {
    //             // No Create allowed on Settings.
    //             return dispatch => {
    //                 let errorMsg = 'Deleting ' + that.name + ' is not allowed'
    //                 dispatch(fns.failure('DELETE', errorMsg));
    //                 dispatch(alertActions.error(errorMsg));
    //             }
    //         }
    //     }
    // }
}

const fieldsMeta = {
    userNames: {
        label: 'User Name',
        min: 3,
        max: 20,
        type: 'select',
        required: true,
        placeholder: 'Please specify the User Name',
        api: {
            path: 'ticketing/User/getUsersByAgent',
            method: 'GET',
            //params: { filter: ['queueName'] },
            response: {
                ref: 'data',
                labelKey: 'username',
                valueKey: 'username'
            }
        },
        readOnly: false,
        filterDropDown:true, 
       // width: '20%',
        name: 'userNames',
        isMulti:true
    },
    queueName: {
        label: 'Queue Name',
        required: true,
        type: 'select',
        name: 'queueName',
        api: {
            path: 'ticketing/queue/getQueues',
            createPath: 'ticketing/queue/getQueueNotUsed',
            method: 'GET',
            filters: [{
                field: 'status',
                operator: 'is',
                value : 'Published'
            }],
            limit: 50,
            response: {
                ref: 'data',
                labelKey: 'queueName',
                valueKey: 'queueName'
            }
        },
       // width: '10%',
       readOnlyOnEdit: true,
    },
    status: {
        label: "Status",
        name: 'status',
        options: [{label: 'Published', value: 'Published'}, {label: 'Draft', value: 'Draft'}],
        type: 'select',
        required: true,
        default: 'Published',
       // width:'10%',

    },
    updatedBy: {
        label: 'Last Edited By',
        name: 'updatedBy',
        readOnly: true,
        type: 'text'
    },
    updatedAt: {
        label: 'Last Edited At',
        name: 'updatedAt',
        readOnly: true,
        type: 'datetime-local'
    }
}

const listsMeta = {
    myItems: {
        name: 'myItems',
        api: {
            path: '/getMySettings',
            method: 'GET',
            params: undefined,
            body: undefined,
            response: {
                ref: 'data', // ref key .. could be defaulted to body. Prop that holds the 
                map: { // return columns as. Key is api response object keys. value is what they are returned as
                    caseId: 'itemId',
                    shortDesc: 'title'
                }
            }  
        }
    }
}

const actionsMeta = {
    cancel: {
        label: 'Cancel',
        name: 'cancel',
        action: 'cancelEdit'
    },
    update: {
        label: 'Update',
        name: 'update',
        action: 'upsertItem',
        classes: 'fa fa-pencil fa-lg ',
        type: 'span'
    },
    list: {
        label: 'List All',
        name: 'list',
        action: 'load'
    },
    search: {
        label: 'Search',
        name: 'search',
        action: 'search'
    },
    view: {
        label: 'View',
        name: 'view',
        action: 'getItem',
        classes: 'fa fa-eye fa-lg',
        type: 'span'
    },
    
    create:{
        label: 'Create',
        name : 'create',
        type: 'button',
        action: 'addNewItem',
    },
    createItem:{
        label: 'Create',
        action: 'upsertItem',
        name : 'create',
        type: 'button'
    }
}
const sectionsMeta = {
    general: {
        items: [{name:'status', type: 'field'}, {name:'updatedBy', type: 'field'}, {name:'updatedAt', type: 'field'}]
    },
    basic: {
        title: 'User Queue Details',
        items:[{name:'queueName', type: 'field'}, {name:'userNames', type: 'field'}, {name:'status', type: 'field'}],
        classes:"ticket-form user-queue"
    },

    // object: {
    //     object: {        ref: 'value' }
    //       // show all value object keys as grid key values. All fields are defaulted to text. If value is not of type object then this section is ignored.

    // },
    headerComponent: {
        component: 'DetailHeader',
        
        // props: [] by default pass all parent props as props to the component.
    },
    userQueueForm: {
        cols: [7,5],
        items:[{name: 'basic', type: 'section', col: 1}, 
        {name: 'update', type: 'action', col: 1}],
        classes: 'composite-inner-form'
    },
    createForm: {
        cols: [7,5],
        items:[{name: 'basic', type: 'section', col: 1}, 
        {name: 'createItem', type: 'action', col: 1}],
        classes: 'composite-inner-form'
    },
    documents:{
        component: 'DocumentList', // contains upload control too
        props: { docs :'itemDocuments'}, // means DocumentList will get props.docs with value of collection = itemDocuemnts
        
    },
    notifications: {
        title: 'All Notes',
        type: 'tab',
        items: [{name: 'notesCtrl', type: 'section'}, {name: 'notesList', type: 'section'}]
    },
    // relatedCases: {
    //     title: 'Related Cases',
    //     items: [{name: 'itemRelCtrl', type: 'section'}, {name: 'relList', type: 'section'}],
    //     type: 'tab'
    // },
    stats: {
        type: 'group',
        items: [{name: 'status', type: 'field'},{name: 'submittedBy', type:'field'}, {name: 'requestedFor', type: 'field'},{name:'assignedTo', type: 'field'}
        ],
        classes: 'section-stat'
    },
    userInfo: {
        type: 'group',
        items:[{name:'email', type: 'field'}, {name:'firstName', type: 'field'}, {name:'lastName', type: 'field'}, {name:'location', type: 'field'}]
    },
    notesCtrl: {
        component: 'NotesControl',
        otherProps: { collectionProp: 'notes'}
    },
    notesList: {
        component: 'NotesList',
        props:{list:'notes'}
    },
    relList:{
        component: 'List',
        props:{list:'relatedCases'}
    },
    // itemRelCtrl:{
    //     component: 'RelationControl', // source1 and its fields, source2 and its fields, relation fields , source1List, source2List
    //     propsMeta: {  fields: ['relType', 'possibleRelItems']},
    //     // source 1 and source 2 are getting related.
    //     // source 1 and source 2 can both be dynamic or either static.
    //     // static would mean they can come from meta definition  ( not usual case)
    //     // dynamic ( usual case) can link to a api linked field or api linked list.
    //     // if api linked field can be part of meta definition of the field.
    //     // if api linked list have a list meta to get the lists from apis
    //     lists: [{name: 'myItems', as:'source2'}],
    //     // source2: {type: 'action', name: 'relatedItems'}
    //     // props:{ source2List: 'relCases'} // these are picked from entityValues obj
    // }


    // component: {component: {
    //     name: 'objComponent',
    //     props: [],
    //     propFns: []
    // }}
    // heading:{
    //     items:[{name: 'screenHeading', type: 'static', col: 1 }, 
    //     {name:'listLink', type:'link', col: 2}],
    //     cols: [6,6]
    // },
    // iconAndButtons:{
    //     items: [{name: 'itemIcon', type: 'other', col: 1 }, {name:'itemRef', type:'static', col: 1}, {name: 'buttonGroup', type: 'section', col: 2}],
    //     cols: [3,9]
    // },
    // buttonGroup: {
    //     items:  []
    // }
}


const tabsMeta = {
    tabGroup1: {
        tabs: [ {
            name: 'notifications',
            type: 'section'
        },{
            name: 'relatedCases',
            type: 'section'
        }],
        defaultActive: '1',
        name: 'tabGroup1'
    }
}

const screens = {
    // edit: {
    //     title:{label: 'Edit Settings', col: 1, },
    //     items: [{name:'heading', type: 'section'}],
    //     actions: ['editMap', 'cancel', 'save']
    // },
    view: {
        items: [{name:'headerComponent', type: 'section'}, {name: 'userQueueForm', type: 'section'}],
        classes: 'composite-form',
        title: 'User Queue Details'
    },
    create:{
        items: [{name:'headerComponent', type: 'section'}, {name: 'createForm', type: 'section'}]
    },
    edit:{
        items: [{name:'headerComponent', type: 'section'}, {name: 'userQueueForm', type: 'section'}]
    },
    // view: {
    //     sections: ['general', 'details'],
    //     actions: ['edit']
    // },
    list: {
        items: [{name:'queueName', type: 'link'}, {name:'userNames', type: 'field'},  {name:'status', type: 'field'}, {name:'updatedBy', type: 'field'}, {name:'updatedAt', type: 'field'}],
        // actions: ['view', 'update']
        filter : [{
            name: "status",
            operator: "ne",
            value: "Deleted"
        }],
        multiselect:false
    },
    search: {
        items: [{name:'userNames', type: 'field'}, {name:'queueName', type: 'link'}]
    }
}
// const components = { searchList: EntityComponent} // can overrides the components like this if needed
const UserQueue = new UserQueueEntity({ ActionClass: userQueueAction, fieldsMeta, actionsMeta, sectionsMeta, tabsMeta, screens, name: 'UserQueue', title: 'User Queue', methodSchemas, collectionSchemas,  entitySchema, idKey: 'id', entityUrlPaths:{default: "ticketing/UserQueue" , upsert: "ticketing/UserQueue/upsert-custom" }, fetchDetailByApi: false })

const UserQueueListSearchContainer = UserQueue.getContainer('ListSearch')
const UserQueueCreateContainer = UserQueue.getContainer('Create')
const UserQueueDetailContainer = UserQueue.getContainer('Detail')
export { UserQueueListSearchContainer, UserQueueCreateContainer, UserQueueDetailContainer }